import AhoyEvent from 'shared/ahoy_event';

export default class BannerAdTracker {
  static sendAdEvent(props) {
    var title = 'PLAYBACK::AD';
    props.ad_type = 'banner';
    AhoyEvent.send(title, props);
  }

  static sendAdEventStart(props) {
    props.ad_event = 'START';
    BannerAdTracker.sendAdEvent(props);
  }

  static sendAdEventEmpty(ad_slot, ad_uuid) {
    var props = {
      ad_slot: ad_slot,
      ad_uuid: ad_uuid,
      ad_event: 'EMPTY'
    };
    BannerAdTracker.sendAdEvent(props);
  }

  static sendAdEventImpressionViewable(ad_slot, ad_uuid) {
    var props = {
      ad_slot: ad_slot,
      ad_uuid: ad_uuid,
      ad_event: 'IMPRESSION_VIEWABLE'
    };
    BannerAdTracker.sendAdEvent(props);
  }

  static sendAdEventClick(ad_unit, line_item_id, advertiser_id, order_id, creative_id, ad_size_width, ad_size_height) {
    var props = {};
    props.ad_uuid = window.kmklabs.gpt.ad_unit[`${ad_unit}`].ad_uuid;
    props.ad_slot = window.kmklabs.gpt.ad_unit[`${ad_unit}`].ad_slot;
    props.ad_unit = ad_unit;
    props.ad_event = 'CLICK';
    props.line_item_id = line_item_id;
    props.advertiser_id = advertiser_id;
    props.campaign_id = order_id;
    props.creative_id = creative_id;
    props.size = `[${ad_size_width}, ${ad_size_height}]`;

    BannerAdTracker.sendAdEvent(props);
  }

  static uuid(time = new Date().getTime(), randomFunction = Math.random){
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (time + randomFunction()*16)%16 | 0;
        time = Math.floor(time/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
  }
}
